import { APIS, URLS } from '@/shared/config/urls';
import { request } from '@/shared/utils/request';
import type { Cart } from '../types/cart.types';

export const fetchCart = async (): Promise<Cart> => {
  return await request.get(`${URLS.BACK_DSH}${APIS.cart}`);
};

/** Adds to the line's quantity when the product is already in the cart (max 99). 404 when the
 *  product is hidden or sold out. */
export const addCartItem = async (productId: string, quantity = 1): Promise<Cart> => {
  return await request.post(`${URLS.BACK_DSH}${APIS.cartItems}`, {
    product_id: productId,
    quantity,
  });
};

export const updateCartItem = async (itemId: string, quantity: number): Promise<Cart> => {
  return await request.patch(`${URLS.BACK_DSH}${APIS.cartItem(itemId)}`, { quantity });
};

export const removeCartItem = async (itemId: string): Promise<Cart> => {
  return await request.delete(`${URLS.BACK_DSH}${APIS.cartItem(itemId)}`);
};

/** Ids no longer in the cart are ignored. */
export const removeCartItems = async (itemIds: string[]): Promise<Cart> => {
  return await request.delete(`${URLS.BACK_DSH}${APIS.cartItems}`, {
    data: { item_ids: itemIds },
  });
};
